export default {
  roundtrip: {
    'roundtripOptions': 'Körutazás beállításai'
  }
}
